import { Api } from "./Api"


const carregaCobrancas = async(provider_id,user_id,limit,page) => {
      const { data } = await Api.get(
        `/cobranca/generica/${provider_id}/${user_id}/${limit}/${page}`
      );
      const onlyOpenCharges = data.cobrancas.filter(
        (item) => item.status_pagamento === "A"
      );
      data.cobrancas = onlyOpenCharges;
      return data
  }

const carregaNegociadas = async(usuario_id,provider_id) =>{

  const { data } = await Api.get(`genericnegotiation/list/${usuario_id}/${provider_id}`);
  
      return data
}

const carregaParcelasCartao = async (value,bandeira) => {
    const { data } = await Api.get(
      `parcelamentos/list/${value}/C/5/${bandeira}`
    );
    return data;
};

export {carregaCobrancas, carregaNegociadas, carregaParcelasCartao}